import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Calendar, Mail, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const BookingSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const confirmed = searchParams.get('confirmed');

  return (
    <div className="min-h-screen bg-black pt-24 flex items-center justify-center" data-testid="booking-success-page">
      <div className="container-luxury">
        <div className="max-w-lg mx-auto text-center card-luxury p-8 md:p-12">
          <div className="w-20 h-20 mx-auto mb-6 bg-[#C9A14A]/10 rounded-full flex items-center justify-center">
            <CheckCircle className="w-10 h-10 text-[#C9A14A]" />
          </div>
          
          <h1 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white mb-4">
            Booking Confirmed!
          </h1>
          
          <p className="text-gray-400 mb-8">
            Thank you for your booking. We've sent a confirmation email with your unique access code.
          </p>

          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-center gap-3 text-gray-300">
              <Mail className="w-5 h-5 text-[#C9A14A]" />
              <span>Check your email for your confirmation code (LVL-XXXX)</span>
            </div>
            <div className="flex items-center justify-center gap-3 text-gray-300">
              <Calendar className="w-5 h-5 text-[#C9A14A]" />
              <span>Your session date has been added to our calendar</span>
            </div>
          </div>

          <p className="text-sm text-gray-500 mb-8">
            Use your confirmation code to access your private gallery after your session.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="btn-outline w-full sm:w-auto">
                Back to Home
              </Button>
            </Link>
            <Link to="/client-access">
              <Button className="btn-gold w-full sm:w-auto flex items-center gap-2">
                Client Access
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSuccessPage;
